import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import {
    Grid,
} from '@material-ui/core';

import {
    ColorPicker,
} from 'material-ui-color';

import {
    Typography,
    // Button,
} from '../../../../components/Wrappers/Wrappers.jsx';
import SelectSearch from '../../../../commons/ecal/singleselectsearch';
import Language from '../../../../commons/util/Language.json';
import { colorPickerValueToHex } from '../../../../utils';
import useStyles from './styles';
import ImageSelectUI from './imageSelectUI';

function languageWithAutoDetect () {
    return Language.reduce((current, lang, index) => {
        if (index === 0) {
            return [{
                value: 'auto',
                label: 'Auto-Detect',
            }];
        }
        return [
            ...current,
            lang,
        ];
    }, []);
}

const AUTO_DETECT_TEXT = 'Select \'Auto Detect\' option and your button display will appear in the user\'s detected language.';
function Basics (props) {
    const classes = useStyles();

    const {
        styleData,
        setStyleData,
    } = props;

    useEffect(() => {
        console.log('Basics.useEffect(): ', styleData);
    }, [styleData]);

    return (
        <React.Fragment>
                <Grid
                    container
                    item
                    className={classes.sectionRoot}>

                        <Grid className={classes.sectionContent}>
                            <Grid className={classes.colorPicker} >
                                <Typography
                                    variant='body1'
                                    className={classes.colorPickerText}
                                >
                                    Button Colour
                                </Typography>
                                <ColorPicker
                                    value={styleData.secondaryColour}
                                    defaultValue='#000'
                                    onChange={(value) => {
                                        setStyleData({
                                            ...styleData,
                                            // secondaryColour: '#' + value.hex,
                                            secondaryColour: colorPickerValueToHex(value),
                                        });
                                    }}
                                    hideTextfield
                                    />
                            </Grid>

                            <Grid className={classes.colorPicker} >
                                <Typography
                                    variant='body1'
                                    className={classes.colorPickerText}
                                >
                                    Heading Colour
                                </Typography>
                                <ColorPicker
                                    value={styleData.headingColour}
                                    defaultValue='#000'
                                    onChange={(value) => {
                                        setStyleData({
                                            ...styleData,
                                            // headingColour: '#' + value.hex,
                                            headingColour: colorPickerValueToHex(value),
                                        });
                                    }}
                                    hideTextfield
                                    />
                            </Grid>

                            <Grid
                                className={classes.input}
                            >
                                 <Grid className={classes.logoTitle}>
                                    <Typography
                                            variant={'body1'}
                                            // weight='medium'
                                        >
                                            Language
                                    </Typography>
                                </Grid>
                                <SelectSearch
                                    data-intercom-target={'button-design-language'}
                                    dataIntercomTarget='basic-widget-language'
                                    selected={styleData.language ? [styleData.language] : undefined}
                                    onSelect={(data) => {
                                        setStyleData({
                                            ...styleData,
                                            language: data[0],
                                        });
                                    }}
                                    helperText={(
                                        <Typography
                                            variant={'sub1'}
                                        >
                                            <b> Auto-detection! </b>
                                            { AUTO_DETECT_TEXT }
                                        </Typography>
                                    )}
                                    placeHolder='Default Language'
                                    dataProvider={languageWithAutoDetect()}
                                />
                            </Grid>

                            <ImageSelectUI
                                  styleData={styleData}
                                  setStyleData={setStyleData}
                                  title="Logo"
                                  wizardTitle='Logo Types'
                                  type="logo"
                                  imagePropField="logo"
                                  imageSource={styleData.logo}
                            />

                        </Grid>

                </Grid>
        </React.Fragment>
    );
};

Basics.propTypes = {
    setStyleData: PropTypes.func,
    uploadButtonLogo: PropTypes.func,
    styleData: PropTypes.object,

    buttonLogo: PropTypes.any,
    imageError: PropTypes.bool,
    buttonLogoError: PropTypes.string,
    isUploading: PropTypes.bool,
};

Basics.defaultProps = {
    setStyleData: () => {},
    uploadButtonLogo: () => {},
    styleData: {},
    buttonLogo: null,
    imageError: false,
    buttonLogoError: '',
    isUploading: false,
};

export default Basics;
